/* eslint-disable import/no-anonymous-default-export */
import coreApi from "../../lib/coreApi";
import { userCanAccess } from "../../lib/permissions";

// Safely read the stored login user (used to pick role-scoped endpoint prefixes).
const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    return null;
  }
};

const toQuery = (data = {}) => {
  let qp = "";
  for (var key in data) {
    if (
      data.hasOwnProperty(key) &&
      data[key] !== undefined &&
      data[key] !== null &&
      data[key] !== ""
    ) {
      qp = qp + `&${key}=${encodeURIComponent(data[key])}`;
    }
  }
  if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
  return qp;
};

export default {
  downloadEmployeePaymentStatement: ({ employeeId, start_time, end_time }) => {
    const qp = toQuery({ start_time, end_time });
    const url = `/backoffice/employees/${employeeId}/payments/pdf${qp}`;
    return coreApi.DOWNLOAD(url);
  },
  getPaymentList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    const user = getStoredUser();
    const prefix = userCanAccess(user, "payments.view")
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin"
        : "";
    
    let url = `${prefix}/payments${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getPaymentsCount: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    const user = getStoredUser();
    const prefix = userCanAccess(user, "payments.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : "";
    let url = `${prefix}/payments${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getPaymentWDList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    const user = getStoredUser();
    const prefix = userCanAccess(user, "payments.view")
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin"
        : ""

    let url = `${prefix}/payments-wd/${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getPaymentDownload: (data) => {
    // let url = "/backoffice/payments/download";
    let qp = toQuery(data);
    let url = `/backoffice/payments/orion${qp}`;
    let result = coreApi.DOWNLOAD(url);
    return result;
  },
  getPaymentInfo: (payment_id) => {
    const user = getStoredUser();
    const prefix = userCanAccess(user, "payments.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : "";
    let url = `${prefix}/payments/${payment_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  settlePayment: (data, payment_id) => {
    let url = `/backoffice/payments/${payment_id}/settle`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getMonthsToSettle: (employee_id) => {
    let url = `/backoffice/employees/${employee_id}/settle`;
    let result = coreApi.GET(url);
    return result;
  },
  getBulkMonthsToSettle: (country) => {
    let url = `/backoffice/employees/settle?country=${country}`;
    return coreApi.GET(url);
  },
  settleSalary: (employee_id, date) => {
    let url = `/backoffice/employees/${employee_id}/settle`;
    let data = date ? { date } : {};
    let result = coreApi.POST(url, data);
    return result;
  },
  bulkSettleSalary: (employees_ids, date) => {
    let url = `/backoffice/employees/settle`;
    let result = coreApi.POST(url, { employees_ids, date });
    return result;
  },
  getCompanyList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    // Use the backoffice endpoint for superadmins OR any user granted `companies.view`;
    // otherwise fall back to the admin scoped endpoint.
    const user = getStoredUser();
    const prefix = userCanAccess(user, "companies.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : "";
    let url = `${prefix}/companies${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getCompanyInfo: (company_id) => {
    const user = getStoredUser();
    const prefix = userCanAccess(user, "companies.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : "";
    let url = `${prefix}/companies/${company_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  getEmployeeList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    // Use the backoffice endpoint for superadmins OR any user granted `employees.view`;
    // otherwise fall back to the admin / hr scoped endpoints.
    const user = getStoredUser();
    const prefix = userCanAccess(user, "employees.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr
          ? "/hr"
          : "";
    let url = `${prefix}/employees${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getEmployeeInfo: (employee_id) => {
    const user = getStoredUser();
    const prefix = userCanAccess(user, "employees.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr
          ? "/hr"
          : "";
    let url = `${prefix}/employees/${employee_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  getOverview: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/overview/extended${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  inviteCompany: (data) => {
    let url = `/backoffice/companies/invite`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateCompany: ({ company_id, data }) => {
    let url = `/backoffice/companies/${company_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getExchangeList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/exchanges${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getExchangeInfo: (exchange_id) => {
    let url = `/backoffice/exchanges/${exchange_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  createExchange: (data) => {
    let url = `/backoffice/exchanges`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateExchange: (data, exchange_id) => {
    let url = `/backoffice/exchanges/${exchange_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteExchange: (exchange_id) => {
    let url = `/backoffice/exchanges/${exchange_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  getDeductionList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/deductions${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getDeductionInfo: (deduction_id) => {
    let url = `/backoffice/deductions/${deduction_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  createDeduction: (data) => {
    let url = `/backoffice/deductions`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateDeduction: (data, deduction_id) => {
    let url = `/backoffice/deductions/${deduction_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteDeduction: (deduction_id) => {
    let url = `/backoffice/deductions/${deduction_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  getBonusList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === undefined || data[key] === "")
          continue;
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/bonuses${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getBonusInfo: (bonus_id) => {
    let url = `/backoffice/bonuses/${bonus_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  createBonus: (data) => {
    let url = `/backoffice/bonuses`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateBonus: (data, bonus_id) => {
    let url = `/backoffice/bonuses/${bonus_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteBonus: (bonus_id) => {
    let url = `/backoffice/bonuses/${bonus_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  getBonusClaimList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === undefined || data[key] === "")
          continue;
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/bonus-claims${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getBonusClaimInfo: (claim_id) => {
    let url = `/backoffice/bonus-claims/${claim_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  deleteBonusClaim: (claim_id) => {
    let url = `/backoffice/bonus-claims/${claim_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  /* --------------------------- Role Groups --------------------------- */
  // Capability catalogue — plain array (NOT paginated).
  getPermissionCatalogue: () => {
    return coreApi.GET(`/backoffice/permissions`);
  },
  getGroupList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === undefined || data[key] === "")
          continue;
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/groups${qp}`;
    return coreApi.GET(url);
  },
  getGroup: (group_id) => {
    return coreApi.GET(`/backoffice/groups/${group_id}`);
  },
  createGroup: (data) => {
    return coreApi.POST(`/backoffice/groups`, data);
  },
  updateGroup: (data, group_id) => {
    return coreApi.PATCH(`/backoffice/groups/${group_id}`, data);
  },
  deleteGroup: (group_id) => {
    return coreApi.DELETE(`/backoffice/groups/${group_id}`);
  },
  getGroupMembers: (data, group_id) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === undefined || data[key] === "")
          continue;
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/groups/${group_id}/members${qp}`;
    return coreApi.GET(url);
  },
  addGroupMembers: (data, group_id) => {
    // data: { user_ids: [...] } -> returns the FULL updated member array.
    return coreApi.POST(`/backoffice/groups/${group_id}/members`, data);
  },
  removeGroupMembers: (data, group_id) => {
    // DELETE with a body -> returns the FULL updated member array.
    return coreApi.DELETE_WITH_BODY(`/backoffice/groups/${group_id}/members`, data);
  },
  /* -------------------- Notifications (current user) -------------------- */
  getNotificationCount: () => {
    return coreApi.GET(`/backoffice/notifications/count`);
  },
  getNotifications: (data) => {
    // data: { is_read, intent, page, page_size }
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (data[key] === null || data[key] === undefined || data[key] === "")
          continue;
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    return coreApi.GET(`/backoffice/notifications${qp}`);
  },
  markNotificationRead: (notification_id) => {
    return coreApi.POST(`/backoffice/notifications/${notification_id}/read`, {});
  },
  markAllNotificationsRead: () => {
    return coreApi.POST(`/backoffice/notifications/read-all`, {});
  },
  // ── Payment-gateway config (Fortress) — super-only ──────────────────────
  // Companies currently routed through Fortress (everyone else = Paystack).
  getFortressCompanies: () => {
    return coreApi.GET(`/backoffice/gateway/fortress-companies`);
  },
  // Whole-list replace: send the full set of Fortress company ids.
  updateFortressCompanies: (data) => {
    return coreApi.PUT(`/backoffice/gateway/fortress-companies`, data);
  },
  // Bank → Fortress institution_code resolutions. Supports exact filters
  // (bank_name/bank_code/institution_code), `search`, pagination, and history=true.
  getFortressBankCodes: (data) => {
    let qp = "";
    for (var key in data) {
      if (
        data.hasOwnProperty(key) &&
        data[key] !== undefined &&
        data[key] !== null &&
        data[key] !== ""
      ) {
        qp = qp + `&${key}=${encodeURIComponent(data[key])}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    return coreApi.GET(`/backoffice/fortress-bank-code-resolution${qp}`);
  },
  // Update a resolution by id. For now only bank_code is editable.
  updateFortressBankCode: (data, id) => {
    return coreApi.PATCH(`/backoffice/fortress-bank-code-resolution/${id}`, data);
  },
  getTransactionHistory: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    
    const user = getStoredUser();
    const prefix = userCanAccess(user, "transactions.view")
      ? "/backoffice"
      : user?.is_admin
        ? "/admin"
        : user?.is_hr
          ? "/hr"
          : "";
    let url = `${prefix}/transactions${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getFeesList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/fees${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  createFees: (data) => {
    let url = `/backoffice/fees`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateFees: (data) => {
    let url = `/backoffice/fees`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getPaymentWithPaystackReference: (data) => {
    let url = `/payments-with/paystack-reference`;
  },
  declinePayment: (data, payment_id) => {
    let url = `/backoffice/payments/${payment_id}/decline`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getAnalysisReports: (reportsType, data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/reports/${reportsType}${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  pushNotification: (data) => {
    let url = "/push-notifications/";

    let result = coreApi.POST(url, data);
    return result
  },
  sendCompanyMonthlyReports: (data) => {
    let url = "/backoffice/send-reports";
    let result = coreApi.POST(url, data);
    return result;
  },
  sendCompanyCustomReports: (data) => {
    let url = "/backoffice/send-report/companies";
    let result = coreApi.POST(url, data);
    return result;
  },
  updateCompanyPayments: (data, payment_id) => {
    let url = `/backoffice/company/payments/${payment_id}`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  getWithdrawalLimitCategories: (filters) => {
    let url = `/backoffice/withdrawal-limits`;
    let qp = "";
    for (var key in filters) {
      if (filters.hasOwnProperty(key)) {
        qp = qp + `&${key}=${filters[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    return coreApi.GET(`${url}${qp}`);
  },
  createWithdrawalLimitCategory(data) {
    let url = `/backoffice/withdrawal-limits`;

    return coreApi.POST(url, data);
  },
  updateWithdrwalLimitCategory(id, data) {
    let url = `/backoffice/withdrawal-limits/${id}`;

    return coreApi.PATCH(url, data);
  },
  getWithdrwalLimitCategory(id) {
    let url = `/backoffice/withdrawal-limits/${id}`;

    return coreApi.GET(url);
  },
  deleteWithdrawalLimitCategory(id) {
    let url = `/backoffice/withdrawal-limits/${id}`;

    return coreApi.DELETE(url);
  },

  getMerchantList: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `/backoffice/vendors${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  getMerchantInfo: (merchant_id) => {
    let url = `/backoffice/vendors/${merchant_id}`;
    let result = coreApi.GET(url);
    return result;
  },
  getVendorPayments: (vendor_id, data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/vendors/${vendor_id}/payments${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  inviteMerchant: (data) => {
    let url = `/backoffice/vendors/invite`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateMerchant: (merchant_id, data) => {
    let url = `/backoffice/vendors/${merchant_id}`;
    let result = coreApi.formPATCH(url, data);
    return result;
  },
  reactivateVendor: (vendor_id) => {
    let url = `/backoffice/vendors/${vendor_id}/reactivate`;
    let result = coreApi.POST(url, { status: "ACTIVE" });
    return result;
  },
  suspendVendor: (vendor_id) => {
    let url = `/backoffice/vendors/${vendor_id}/suspend`;
    let result = coreApi.POST(url, { status: "suspended".toUpperCase() });
    return result;
  },
  hrToAdmin(data) {
    let url = `/backoffice/hr/to-admin`;

    return coreApi.POST(url, data);
  },
  getUserActivityLogs(data) {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    // Use the backoffice endpoint for superadmins OR any user granted `logs.view`;
    // otherwise fall back to the admin scoped endpoint.
    const user = getStoredUser();
    const prefix = userCanAccess(user, "logs.view")
      ? "backoffice"
      : user?.is_admin
        ? "admin"
        : "";

    let url = `/${prefix}/users-activity-logs/`;
    url = `${url}${qp}`
    return coreApi.GET(url)
  },
  getVendorFees: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/vendors/fees${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  createVendorFees: (data) => {
    let url = `/backoffice/vendors/fees`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateVendorFees: (data) => {
    let url = `/backoffice/vendors/fees`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteVendorFees: (fee_range_id) => {
    let url = `/backoffice/vendors/fees/${fee_range_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  // Company fee ranges — mirrors the vendor fees endpoints. The list uses
  // ?history=true (unpaginated) and is scoped to the admin's country server-side.
  getCompanyFees: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/companies/fees${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  createCompanyFees: (data) => {
    let url = `/backoffice/companies/fees`;
    let result = coreApi.POST(url, data);
    return result;
  },
  updateCompanyFees: (data) => {
    let url = `/backoffice/companies/fees`;
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteCompanyFees: (fee_range_id) => {
    let url = `/backoffice/companies/fees/${fee_range_id}`;
    let result = coreApi.DELETE(url);
    return result;
  },
  getVendorSettlements: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/vendor-settlements${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  addVendorBankDetails: ({ vendor_id, data }) => {
    let url = `backoffice/vendors/${vendor_id}/banks`
    let result = coreApi.POST(url, data);
    return result;
  },
  updateVendorBankDetails: ({ vendor_id, bank_id, data }) => {
    let url = `backoffice/vendors/${vendor_id}/banks/${bank_id}`
    let result = coreApi.PATCH(url, data);
    return result;
  },
  deleteVendorBankDetails: ({ vendor_id, bank_id }) => {
    let url = `backoffice/vendors/${vendor_id}/banks/${bank_id}`
    let result = coreApi.DELETE(url);
    return result;
  },
  getVendorBankDetails: ({ vendor_id, bank_id }) => {
    let url = `backoffice/vendors/${vendor_id}/banks/${bank_id}`
    let result = coreApi.GET(url);
    return result;
  },
  listVendorBankDetails: ({ vendor_id }) => {
    let url = `backoffice/vendors/${vendor_id}/banks`
    let result = coreApi.GET(url);
    return result;
  },
  getPaystackBanksList: (data = {}) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/paystack/banks${qp}`;
    let result = coreApi.GET(url);
    return result;
  },
  verifyPaystackBankAccount: (data) => {
    let url = `/paystack/verify-account`;
    let result = coreApi.POST(url, data);
    return result;
  },
  vendorOutstandingSettlementTrigger: ({ vendor_id }) => {
    let url = `/backoffice/vendors/${vendor_id}/settlements/outstanding/trigger`

    let result = coreApi.POST(url, {});
    return result
  },
  vendorOutstandingSettlementTriggerAggregate: ({ vendor_id, ...others }) => {
    let qp = "";
    for (var key in others) {
      if (others.hasOwnProperty(key)) {
        qp = qp + `&${key}=${others[key]}`;
      }
    }
    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");
    let url = `/backoffice/vendors/${vendor_id}/settlements/outstanding/trigger${qp}`

    let result = coreApi.GET(url);
    return result
  },
  venodrResendInvitation: ({ vendor_id }) => {
    let url = `/backoffice/vendors/${vendor_id}/resend-invitation`;

    let result = coreApi.POST(url, {});
    return result;
  },
  onBoardCompanyEmployees: ({company_id, dataPayload}) => {
    let url = `/backoffice/employees/${company_id}/invite`;
    return coreApi.POST(url, dataPayload);
  },
  fetchCampaignConfig: () => {
    return coreApi.GET("/backoffice/campaigns/config");
  },
  fetchCampaigns: (filters = {}) => {
    return coreApi.GET(`/backoffice/campaigns${toQuery(filters)}`);
  },
  fetchCampaign: (campaignId) => {
    return coreApi.GET(`/backoffice/campaigns/${campaignId}`);
  },
  createCampaign: (payload) => {
    return coreApi.POST("/backoffice/campaigns", payload);
  },
  updateCampaign: (campaignId, payload) => {
    return coreApi.PATCH(`/backoffice/campaigns/${campaignId}`, payload);
  },
  submitReview: (campaignId, payload = {}) => {
    return coreApi.POST(`/backoffice/campaigns/${campaignId}/submit-review`, payload);
  },
  approveCampaign: (campaignId, payload = {}) => {
    return coreApi.POST(`/backoffice/campaigns/${campaignId}/approve`, payload);
  },
  activateCampaign: (campaignId, payload = {}) => {
    return coreApi.POST(`/backoffice/campaigns/${campaignId}/activate`, payload);
  },
  deactivateCampaign: (campaignId, payload = {}) => {
    return coreApi.POST(`/backoffice/campaigns/${campaignId}/deactivate`, payload);
  },
  endCampaign: (campaignId, payload = {}) => {
    return coreApi.POST(`/backoffice/campaigns/${campaignId}/end`, payload);
  },
  fetchCampaignStats: (campaignId) => {
    return coreApi.GET(`/backoffice/campaigns/${campaignId}/stats`);
  },
  fetchCampaignHistory: (campaignId, pagination = {}) => {
    return coreApi.GET(`/backoffice/campaigns/${campaignId}/history${toQuery(pagination)}`);
  },
};

